import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SEOModelData } from '../Model/SEOModel';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  constructor(private title: Title, private meta: Meta) { }
  getSeo(pageType: string, SearchKeyword : string): SEOModelData {
    // Example SEO data for Flight page
    var CompName = environment.companyShortName;
    const seoData = new SEOModelData();
    if (pageType === 'Flight-Home') {
      seoData.Title = 'Flight Booking,'+ SearchKeyword +' Cheap Flights, Air tickets at Lowest Airfare Online | ' + CompName;
      seoData.metaKeyword = 'flight flight booking, flight ticket, flight ticket booking, flights, cheap flight ticket, air ticket, cheap air ticket, cheap flights, air ticket booking, online flight ticket booking, cheap flight booking"';
      seoData.metaDescription = 'flight "Book cheap flight tickets with | ' + CompName + '| at lowest airfare. Apply Coupon Code: EASEFLY to get up to Rs. 3,000 off on flight tickets for all major destinations in India and abroad.';
    }
    else if (pageType === 'Flight-result') {
      seoData.Title = 'Lowest Airfare '+ SearchKeyword +' , Flight Tickets, Cheap Air Tickets |' + CompName;
      seoData.metaKeyword = 'Lowest Airfare ' + SearchKeyword +' , Flight Tickets, Cheap Air Tickets';
      seoData.metaDescription = 'Lowest Airfare ' + SearchKeyword +' , Flight Tickets, Cheap Air Tickets';
    }
    else if (pageType === 'Flight-Passanger') {
      seoData.Title = 'Flight-Passanger' + CompName;
      seoData.metaKeyword = 'Flight-Passanger';
      seoData.metaDescription = 'Flight-Passanger';
    }
    // hotel
    else if (pageType === 'Hotel-Home') {
      seoData.Title = 'Online Hotels Booking, Book Budget hotels, Luxury and Cheap Hotel |' + CompName;
      seoData.metaKeyword = 'hotels, hotel, booking hotel, hotel room, cheap hotel, online hotel booking, hotel room booking, room booking, hotel rooms, best hotel, best hotel booking site, cheap hotel booking, cheap hotel booking sites ';
      seoData.metaDescription = 'Book Your Dream Hotel With the Lowest Price. ' + CompName+' offers Luxury hotels, budget, and Cheap hotels with the best prices and free cancellation options.';
    }
    else if (pageType === 'Hotel-results') {
      seoData.Title = CompName+': Hotels in '+SearchKeyword+', Hotel Booking Online | Budget , Luxury & Cheap Hotel';
      seoData.metaKeyword = CompName + ': Hotels in ' + SearchKeyword +', Hotel Booking Online | Budget, Luxury & Cheap Hotel';
      seoData.metaDescription = CompName + ': Hotels in ' + SearchKeyword +', Hotel Booking Online | Budget, Luxury & Cheap Hotel';
    }
    else if (pageType === 'Hotel-detail') {
      seoData.Title = 'Hotel-detail';
      seoData.metaKeyword = 'Hotel-detail metakeyword testing';
      seoData.metaDescription = 'Hotel-detail metadescription testing';
    }
    else if (pageType === 'Hotel-Passanger') {
      seoData.Title = CompName + ': Hotel Booking Online | Budget , Luxury & Cheap Hotel';
      seoData.metaKeyword = 'Hotel Booking Online | Budget , Luxury & Cheap Hotel';
      seoData.metaDescription = 'Hotel Booking Online | Budget , Luxury & Cheap Hotel';
    }
    // Holiday
    else if (pageType === 'Holiday-Home') {
      seoData.Title = CompName + ': Book Personalized & Customized Holiday Packages Online';
      seoData.metaKeyword = 'holiday destinations, holiday packages, honeymoon packages, tour packages, cheap holiday packages, travel, honeymoon, packages, holidays, easemytrip';
      seoData.metaDescription = 'Book customized holidays, vacation tour packages and weekend gateways with  |' + CompName +'|, Get travel deals on holiday tour packages and save more!';
    }
    else if (pageType === 'Holiday-results') {
      seoData.Title = CompName + ': Holiday for ' + SearchKeyword +', Holiday Tour Packages Online';
      seoData.metaKeyword = SearchKeyword +' honeymoon packages, europe leisure packages, europe family packages, europe luxury packages, europe bus packages, europe winter fest packages, europe family packages,europe holidays,europe holiday,europe holiday packages,europe trip,europe trip packages,europe holiday packages online ';
      seoData.metaDescription = 'Book ' + SearchKeyword +' holiday tour packages online at the best price with |' + CompName +'|, Get exclusive deals on europe tour packages and save more.';
    }
    else if (pageType === 'Holiday-details') {
      seoData.Title = 'Book Personalized & Customized Holiday Packages Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized Holiday Packages Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized Holiday Packages Online |' + CompName;
    }
    else if (pageType === 'Holiday-passenger') {
      seoData.Title = 'Book Personalized & Customized Holiday Packages Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized Holiday Packages Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized Holiday Packages Online |' + CompName;
    }
    // Transfer
    else if (pageType === 'Transfer-Home') {
      seoData.Title = 'Book Personalized & Customized Transfer Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized Transfer Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized Transfer Online |' + CompName;
    }
    else if (pageType === 'Transfer-result') {
      seoData.Title = 'Book Personalized & Customized Transfer Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized Transfer Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized Transfer Online |' + CompName;
    }
    else if (pageType === 'Transfer-passenger') {
      seoData.Title = 'Book Personalized & Customized Transfer Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized Transfer Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized Transfer Online |' + CompName;
    }
    else if (pageType === 'Transfer-details') {
      seoData.Title = 'Book Personalized & Customized Transfer Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized Transfer Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized Transfer Online |' + CompName;
    }
    // Seightseeing
    else if (pageType === 'Seightseeing-Home') {
      seoData.Title = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
    }
    else if (pageType === 'Seightseeing-result') {
      seoData.Title = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
    }
    else if (pageType === 'Seightseeing-Passenger') {
      seoData.Title = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
    }
    else if (pageType === 'Seightseeing-details') {
      seoData.Title = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
      seoData.metaKeyword = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
      seoData.metaDescription = 'Book Personalized & Customized SeightSeeing Online |' + CompName;
    }
    else if (pageType === 'index-page') {
      seoData.Title = CompName + ' - Book Flights, Hotels, Holidays, Seightseeing & Transfer Booking';
      seoData.metaKeyword = 'cheap air tickets, cheapest flight booking, flight tickets, airline tickets, flight bookings, hotel reservations, holidays, travel deals, affordable flights, lowest airfare, online booking with ' + CompName;
      seoData.metaDescription = 'Discover the best deals on flights, hotels, holiday packages, bus & train tickets. Exclusive offers to make travel dreams a reality at ' + CompName;
    }
    return seoData;
  }
}
